import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { RelatedTasksMode } from '../related-tasks-tab.type';
import { FiltersEpics } from './filters-epics';
import { FiltersInitiatives } from './filters-initiatives';
import { FiltersOutcomes } from './filters-outcomes';
import { FiltersTasks } from './filters-tasks';
import { FiltersTeams } from './filters-teams';

export const FiltersList = () => {
  const mode = useRelatedTasksTabStore((state) => state.mode);

  switch (mode) {
    case RelatedTasksMode.ContributingTasks:
      return <FiltersTasks />;
    case RelatedTasksMode.ContributingEpics:
      return <FiltersEpics />;
    case RelatedTasksMode.ContributingTeams:
      return <FiltersTeams />;
    case RelatedTasksMode.ContributingInitiatives:
      return <FiltersInitiatives />;
    case RelatedTasksMode.ContributingOutcomes:
      return <FiltersOutcomes />;
    default:
      return null;
  }
};
